module.exports = __webpack_public_path__ + "static/keyword_2-724843bdc6497c325e727089aa6e929f.jpg";